module.exports = __webpack_public_path__ + "img/19.c6527c6d.svg";